import { Play } from 'lucide-react';
import { formatDuration, isVideoMedia, mediaThumbUrl } from '../lib/mediaLibrary';

/**
 * Grid-tile contents for a media-library item: the image thumbnail, or a video
 * poster (first frame) with a duration badge. Fills its positioned parent.
 */
export default function MediaTileMedia({
  url,
  mimeType,
  durationSeconds,
  alt,
}: {
  url: string;
  mimeType?: string | null;
  durationSeconds?: number | null;
  alt?: string;
}) {
  if (isVideoMedia({ mime_type: mimeType, url })) {
    return (
      <>
        <video
          src={`${url}#t=0.1`}
          muted
          playsInline
          preload="metadata"
          className="w-full h-full object-cover pointer-events-none"
          aria-label={alt || 'Video'}
        />
        <span className="absolute bottom-1.5 right-1.5 z-[1] inline-flex items-center gap-0.5 rounded-md bg-black/70 px-1.5 py-0.5 text-[10px] font-semibold text-white pointer-events-none">
          <Play className="h-2.5 w-2.5 fill-white" />
          {durationSeconds ? formatDuration(durationSeconds) : 'Video'}
        </span>
      </>
    );
  }

  return (
    <img
      src={mediaThumbUrl(url)}
      alt={alt || ''}
      className="w-full h-full object-cover"
      loading="lazy"
    />
  );
}
